export const FORM_ID = 'change-license';
export const MOVE_TEXT = 'Move';
export const CANCEL_TEXT = 'Cancel';
export const SAVE_TEXT = 'Save';
export const USER_MOVED_SUCCESSFULLY_MESSAGE = 'User has been moved successfully.';
export const MOVE_CONFIRMATION_MESSAGE = 'Are you sure you want to move this licensed user?';
export const FORM_INCOMPLETE_MESSAGE = 'Please complete all required fields.';
